export default __webpack_public_path__ + "static/vimium_help-fd558c289d0ab2ed4930bc28d9e38154.png";